// removed by extract-text-webpack-plugin
module.exports = {"MainWrapper":"FeatureIcons-module__MainWrapper__NPD7O","CarouselWrapper":"FeatureIcons-module__CarouselWrapper__2obI9","Star":"FeatureIcons-module__Star__3RLo4","View":"FeatureIcons-module__View__U44wJ","Chat":"FeatureIcons-module__Chat__1YMh0","QuickMatch":"FeatureIcons-module__QuickMatch__1Cucs","Likes":"FeatureIcons-module__Likes__1aCIG","HeartStar":"FeatureIcons-module__HeartStar__3Ppdv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexMain/FeatureIcons/FeatureIcons.module.css
// module id = 1717
// module chunks = 31